import React from "react";

function ContactIcon() {
  return (
    <svg
      width="24px"
      height="24px"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <g>
        <g>
          <path d="M6,19H4c-2.2,0-4-1.8-4-4v-1c0-2.2,1.8-4,4-4h2c0.6,0,1,0.4,1,1v7C7,18.6,6.6,19,6,19z M4,12c-1.1,0-2,0.9-2,2v1 c0,1.1,0.9,2,2,2h1v-5H4z" />
        </g>
        <g>
          <path d="M20,19h-2c-0.6,0-1-0.4-1-1v-7c0-0.6,0.4-1,1-1h2c2.2,0,4,1.8,4,4v1C24,17.2,22.2,19,20,19z M19,17h1c1.1,0,2-0.9,2-2 v-1c0-1.1-0.9-2-2-2h-1V17z" />
        </g>
        <g>
          <path d="M20.9,12.1c-0.1,0-0.1,0-0.2,0c-0.5-0.1-0.9-0.6-0.8-1.1c0-0.3,0.1-0.6,0.1-1c0-4.4-3.6-8-8-8s-8,3.6-8,8 c0,0.4,0,0.7,0.1,1c0.1,0.5-0.3,1.1-0.8,1.1c-0.5,0.1-1.1-0.3-1.1-0.8C2,10.9,2,10.5,2,10C2,4.5,6.5,0,12,0s10,4.5,10,10 c0,0.5,0,0.9-0.1,1.3C21.8,11.8,21.4,12.1,20.9,12.1z" />
        </g>
        <g>
          <path d="M12,24c-2.2,0-3-1.8-3-3s0.8-3,3-3s3,1.8,3,3c0,0.2,0,0.4-0.1,0.6c2.2-0.6,3.7-2,4.5-4c0.2-0.5,0.8-0.8,1.3-0.6 c0.5,0.2,0.8,0.8,0.6,1.3C20.3,20.9,17.8,24,12,24z M12,20c-0.8,0-1,0.6-1,1c0,0.4,0.2,1,1,1s1-0.6,1-1C13,20.6,12.8,20,12,20z" />
        </g>
      </g>
    </svg>
  );
}

export default ContactIcon;
